import axios from 'axios';
import Errors from './Errors';

export default {
  data() {
    return {
      baseUrl: '',
      userId: null,
    };
  },
  async getActivities() {
    try {
      const { data } = await axios.get(`${this.baseUrl}Activities/`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getActivitiesForAdministration() {
    try {
      const { data } = await axios.get(`${this.baseUrl}Activities/Administration`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getActivity(id) {
    try {
      const { data } = await axios.get(`${this.baseUrl}Activities/${id}`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getPrestationsForActivity(id) {
    try {
      const { data } = await axios.get(`${this.baseUrl}Activities/${id}/Prestations`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async getEntitiesForActivity(id) {
    try {
      const { data } = await axios.get(`${this.baseUrl}Activities/${id}/Entities`);
      return [null, data];
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async saveEntities(id, entities) {
    try {
      const data = await axios.put(`${this.baseUrl}Activities/${id}/Entities`, entities, {
        headers: {
          'Content-Type': 'application/json',
          'User-Id': this.userId,
        },
      });

      return data;
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
  async synchronize(activities) {
    try {
      const data = await axios.put(`${this.baseUrl}Activities/Synchronize`, activities, {
        headers: {
          'Content-Type': 'application/json',
          'User-Id': this.userId,
        },
      });

      return data;
    } catch (error) {
      Errors.onError(error);
      return [error];
    }
  },
};
